import { Breakpoints } from "../../../breakpoints";
import { SlideToggle, isHidden, slideUp, slideDown } from "../../modules/_SlideToggleHelpers";

const el = `featured-development`;
const slideOpts = { miliseconds: 500 };

export const FeaturedDevelopmentList = () => ({
  "x-data": () => ({
    activeItem: null,
    imageStack: [],
  }),
  "x-init"() {
    setTimeout(() => {
      this.$data.activeItem = 0;
    }, 100);
  },
});

const getCurrentItemIndex = (item, allItems) => {
  return [...allItems].findIndex(x => x == item);
}

export const FeaturedDevelopment = () => ({
  "x-data"() {
    return {
      isActive: false,
      image: this.$el.dataset.image,
      itemIndex: getCurrentItemIndex(this.$el, this.$el.parentNode.children),
    }
  },
  "x-init"() {
    this.$watch('activeItem', (activeItemValue) => {
      this.$data.isActive = activeItemValue == this.$data.itemIndex;

      if (this.$data.isActive) {
        this.$data.imageStack.unshift(this.$data.image);
      }
    });
  },
  "@mouseenter"(e) {
    if (window.innerWidth <= Breakpoints.lg) return;

    this.$data.activeItem = getCurrentItemIndex(this.$el, this.$el.parentNode.children);
  },
  "@click"(e) {
    if (window.innerWidth > Breakpoints.lg) return;

    const currentItem = getCurrentItemIndex(this.$el, this.$el.parentNode.children);

    // Open container
    if (currentItem != this.$data.activeItem) {
      e.preventDefault();
      e.stopPropagation();

      this.$data.activeItem = currentItem;
    }
    else {
      // Double click allows link to open
    }
  }
});

export const FeaturedDevelopmentCopySlider = () => ({
  ...SlideToggle,
  "x-init"() {
    this.$watch('open', (openValue) => {
      if (openValue) slideDown(this.$el, slideOpts);
      else slideUp(this.$el, slideOpts);
    });
    this.open = !isHidden(this.$el);

    this.$watch('isActive',(isActiveValue) => {
      this.$data.open = isActiveValue;
    })
  }
});

export const FeaturedDevelopmentsInit = () => {
  Alpine.bind('FeaturedDevelopmentList', FeaturedDevelopmentList);
  Alpine.bind('FeaturedDevelopmentCopySlider', FeaturedDevelopmentCopySlider);
  Alpine.bind('FeaturedDevelopment', FeaturedDevelopment);
}
